import { render, staticRenderFns } from "./FilesPage.vue?vue&type=template&id=42d1f663&scoped=true&"
import script from "./FilesPage.vue?vue&type=script&lang=js&"
export * from "./FilesPage.vue?vue&type=script&lang=js&"
import style0 from "./FilesPage.vue?vue&type=style&index=0&id=42d1f663&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d1f663",
  null
  
)

export default component.exports